const paymentMethodList = [
  { "value": 0, "text": "前払い" },
  { "value": 1, "text": "後払い" },
];
// issuance_requests用
let paymentMethodCode = {
  PREPAID: { code: 0, text: '前払い' },
  POSTPAY: { code: 1, text: '後払い' },
};
// management_companies用
let isPostpayAllowed = {
  NO: { code: 0, text: '否' },
  YES: { code: 1, text: '可' },
};

export function convertPaymentMethodToName(payment_method_code) {
  // 数値から支払方法の可否に変更する
  return paymentMethodList.find(paymentMethod => paymentMethod.value === payment_method_code)?.text ?? '';
}
export default {
  code: paymentMethodCode,
  postpayCode: isPostpayAllowed
};
